<template>
  <div class="query-auth-pre">
    <query-form :config="['创建时间', '生产者账号', '产品名称']" @fetch-data="fetchData"></query-form>

    <count-total :total="dataSource.length">
      <template #btn>
        <a-button
          v-show="dataSource.length > 0"
          type="link"
          icon="copy"
          @click="clickCopy"
        >复制串号和串号密钥</a-button>
      </template>
    </count-total>

    <my-list :dataSource="dataSource" :loading="loading"></my-list>
  </div>
</template>

<script>
import { queryPreActivateDevice } from '../../api/api'

export default {
  name: 'query-auth-pre',

  data() {
    return {
      dataSource: [],
      loading: false
    }
  },

  created() {
    this.fetchData({
      stime: -28800000,
      etime: 11587891746587
    })
  },

  methods: {
    fetchData(params) {
      this.loading = true
      queryPreActivateDevice(params)
        .then(res => {
          if (res.error.code === 0) {
            this.dataSource = res.response.devices
          } else {
            this.dataSource = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    clickCopy() {
      let value = ''
      this.dataSource.forEach(item => {
        value =
          value + `串号${item.serialNumber}串号密钥${item.serialCipher}\n`
      })

      const input = document.createElement('textarea')
      document.body.appendChild(input)
      input.value = value
      input.select()
      document.execCommand('copy')
      this.$message.success('复制成功')
      document.body.removeChild(input)
    }
  }
}
</script>
